var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.76,
    height: 12.929,
    viewBox: "0 0 10.76 12.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-map-pin",
    "data-name": "Icon feather-map-pin",
    transform: "translate(-4 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M14.26,6.38c0,3.8-4.88,7.049-4.88,7.049S4.5,10.175,4.5,6.38a4.88,4.88,0,1,1,9.76,0Z",
    fill: "none",
    stroke: "#60cdf5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M16.753,12.127A1.627,1.627,0,1,1,15.127,10.5,1.627,1.627,0,0,1,16.753,12.127Z",
    transform: "translate(-5.747 -5.747)",
    fill: "none",
    stroke: "#60cdf5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.d13df0a6a0adff8c59fd6caa96c89bac.svg";
export { ForwardRef as ReactComponent };